<div class="table-row-wrapper">
  <ng-content></ng-content>
</div>
